// callback ที่ player ทุกตัวใช้ร่วมกัน ตัวไหนไม่เกี่ยวก็ไม่ต้องเรียก
// onPlaying / onStall / onResume รับ `sample` = { video_time, buffered_sec, player }

import PropTypes from 'prop-types'

export const playerCallbackShape = {
  url: PropTypes.string.isRequired,
  muted: PropTypes.bool,

  onConnecting: PropTypes.func,
  /** ยืนยันแล้วว่าภาพเดินจริง — ไม่ใช่แค่ได้ event จาก <video> */
  onPlaying: PropTypes.func,
  onStall: PropTypes.func,
  onResume: PropTypes.func,
  /** (code, message, sample) — code ใช้ชุดเดียวกับ dict.errors */
  onError: PropTypes.func,
  /** หน่วย KB/s */
  onSpeed: PropTypes.func,
  /** player ปิดเสียงเองเพราะเบราว์เซอร์ไม่ยอมเล่นแบบมีเสียง — ให้ปุ่มเสียงตรงกับจริง */
  onAutoMuted: PropTypes.func,
  /** (resume) ไม่ยอมเล่นอัตโนมัติเลย — resume ต้องถูกเรียกใน click handler ทันที */
  onBlocked: PropTypes.func,
}

// player เก็บ callback ใน ref ให้ effect ผูกกับ url อย่างเดียว — ถ้าผูกกับฟังก์ชันที่สร้างใหม่ทุก render
// player จะถูกถอดแล้วสร้างใหม่ไม่หยุด
export function emit(cbRef, name, ...args) {
  const fn = cbRef.current[name]
  if (fn) fn(...args)
}

// ห้ามกลืน NotAllowedError เงียบ ๆ — วิดีโอจะค้าง pause จนหมดเวลา แล้วกรอบโทษว่าอุปกรณ์ไม่ส่งภาพ
// ต้องดักจาก promise ไม่ใช่เช็คก่อนเล่น เพราะ WebKit ปฏิเสธทีหลังตอนโหลด metadata เสร็จ
export function playQuietly(video, cbRef) {
  if (!video) return
  const blocked = () => emit(cbRef, 'onBlocked', () => playQuietly(video, cbRef))
  const play = () => {
    const p = video.play()
    return p && p.catch ? p : null
  }

  const first = play()
  if (!first) return
  first.catch(err => {
    if (!err || err.name !== 'NotAllowedError') return
    // ไม่มีเสียงก็ยังไม่ยอม (iPhone Low Power Mode / Safari "Never Auto-Play")
    if (video.muted) {
      blocked()
      return
    }
    video.muted = true
    emit(cbRef, 'onAutoMuted')
    const second = play()
    if (second) {
      second.catch(e => {
        if (e && e.name === 'NotAllowedError') blocked()
      })
    }
  })
}
